import moment from 'moment';

export function formatAlertDate(timestampMs, {includeHours = false, utcOffset = 0} = {}) {
  const timeMoment = moment(timestampMs).utcOffset(utcOffset);
  const dateStr = timeMoment.format(`dddd, MMMM Do`);
  if (includeHours) {
    return dateStr + ` at ` + timeMoment.format(`ha`);
  } else {
    return dateStr;
  }
}

// (0.2548, 1) => 25.5%
// (12.342, 0) => 1,234%
export function formatPercent(value, precision) {
  return (
    (value * 100).toLocaleString(undefined, {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    }) + `%`
  );
}

// 1234 => 1,234
export function formatWholeNumber(value) {
  return Number(value.toFixed(0)).toLocaleString();
}

export function pluralize(singular, number, plural) {
  if (number === 1) {
    return singular;
  } else {
    return plural || `${singular}s`;
  }
}

const tokenize = (str) => (str instanceof Object ? str : {text: str});
const isString = (str) => typeof str === `string`;
const combineText = (acc, str) => {
  if (isString(acc[acc.length - 1]) && isString(str)) {
    acc.push(acc.pop() + str);
  } else {
    acc.push(str);
  }
  return acc;
};

// Take a list of strings and objects. Concatenate all adjacent strings, and then map
// the entire list to text block descriptor objects.
export function combine(messageParts) {
  return messageParts.reduce(combineText, []).map(tokenize);
}

export function keywordParam(text, tokenType, className) {
  if (typeof text === `string`) {
    return {text, type: tokenType, class: className};
  }

  // only wrap strings, this makes extra wrapping safe.
  return text;
}

// wrap keywordParam by always applying our highlight class
export function keyword(arg) {
  return keywordParam(arg, `span`, `mp-sh-alert-keyword`);
}

export function percentDiff(value, expectedValue) {
  if (value < expectedValue) {
    return 1 - value / expectedValue;
  } else {
    return value / expectedValue - 1;
  }
}
